import * as mammoth from 'mammoth';
import * as HtmlParsing from "./HtmlParsing.js";
import {aiStore} from "../../index";
import {handleAbort} from "./PdfParser";


async function convertDocxToHtml(file, isEmbedding, abortedFiles) {
    try{
        let imageIndex = 0;
        const imageHandler = {
            convertImage: mammoth.images.inline(async function(image) {
                if (handleAbort(file, abortedFiles, isEmbedding)) {
                    throw ('cancel uploading')
                }
                if (!isEmbedding) {
                    const ext = image.contentType.split("/")[1];
                    const imageBuffer = await image.read();
                    const blob = new Blob([imageBuffer], {type: `image/${ext}`});
                    imageIndex++;
                    const fileId = await HtmlParsing.uploadImageFromFile(blob, file, imageIndex, ext)

                    return {src: `${fileId}`};
                } else {
                    return {src: `embedded image`};
                }
            }),
        };
        if (!isEmbedding){
            aiStore.sendAiProgressLoaderValue(file.name, 50);
        }
        const arrayBuffer = await file.arrayBuffer();
        const result = await mammoth.convertToHtml({ arrayBuffer: arrayBuffer }, imageHandler);
        const html = result.value;
        const htmlChunks = HtmlParsing.splitHtmlIntoChunks(html);
        return htmlChunks;
    } catch {
        return []
    }

}

export { convertDocxToHtml };